import 'styles/global/bottom.drawer.css';

const BottomDrawer = props => {
    return (
        <>
            <div className='Screen' onClick={props.onCancel}></div>
            <div className={`BottomDrawer ${props.className || ''} ${props.closing ? 'closing' : ''}`.trim()} onAnimationEnd={props.onAnimationEnd}>
                <div className='BottomDrawer-inner'>
                    {props.children}
                </div>
            </div>
        </>
    )
}

export default BottomDrawer
